<template>
  <div class="shop-layout" :style="{ '--shop-header-height': headerHeight + 'px' }">
    <Header />

    <!-- 고정된 좌측 사이드바 - 스타일 동적 적용 -->
    <LeftSidebar class="fixed-left-sidebar" :style="{
      top: headerHeight + 'px',
      height: `calc(100vh - ${headerHeight}px)`
    }" />

    <!-- 메인 콘텐츠 - 패딩 동적 적용 -->
    <main class="shop-content" :style="{
      paddingTop: (headerHeight + 20) + 'px'
    }">
      <router-view />
    </main>

    <!-- 고정된 우측 사이드바 -->
    <RightSidebar class="fixed-right-sidebar" />

    <!-- TOP 버튼 -->
    <button class="top-button" @click="scrollToTop">
      <span>TOP</span>
    </button>

    <Footer />
  </div>
</template>

<script>
import Header from '@/views/shop/layouts/Header.vue'
import Footer from '@/views/shop/layouts/Footer.vue'
import LeftSidebar from '@/views/shop/layouts/LeftSidebar.vue'
import RightSidebar from '@/views/shop/layouts/RightSidebar.vue'

export default {
  name: 'ShopLayout',
  components: {
    Header,
    Footer,
    LeftSidebar,
    RightSidebar
  },
  data() {
    return {
      headerHeight: 0,
    }
  },
  mounted() {
    // 초기 헤더 높이 계산
    this.$nextTick(() => {
      this.updateHeaderHeight();
    });

    // 헤더 높이 변경 이벤트 리스너 등록
    window.addEventListener('header-height-changed', this.updateHeaderHeight);
    window.addEventListener('resize', this.updateHeaderHeight);

    // 100ms마다 헤더 높이 체크 (변경 감지를 위한 추가적인 방법)
    this.heightInterval = setInterval(() => {
      this.updateHeaderHeight();
    }, 100);
  },
  beforeUnmount() {
    // 이벤트 리스너 및 인터벌 제거
    window.removeEventListener('header-height-changed', this.updateHeaderHeight);
    window.removeEventListener('resize', this.updateHeaderHeight);
    clearInterval(this.heightInterval);
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    updateHeaderHeight() {
      const headerElement = document.querySelector('.nebula-header-wrapper');
      if (headerElement) {
        const newHeight = headerElement.offsetHeight;
        // 높이가 실제로 변경되었을 때만 업데이트
        if (this.headerHeight !== newHeight) {
          this.headerHeight = newHeight;

          // 좌측 사이드바 위치 업데이트
          const sidebar = document.querySelector('.fixed-left-sidebar');
          if (sidebar) {
            sidebar.style.top = `${this.headerHeight}px`;
            // 브라우저 높이에서 헤더 높이와 푸터 높이를 뺀 값으로 설정
            const footerHeight = document.querySelector('footer') ? document.querySelector('footer').offsetHeight : 0;
            sidebar.style.height = `calc(100vh - ${this.headerHeight}px - ${footerHeight}px)`;
            // 하단 여백 제거
            sidebar.style.marginBottom = '0';
            sidebar.style.paddingBottom = '0';
          }

          // 컨텐츠 패딩 업데이트
          const content = document.querySelector('.shop-content');
          if (content) {
            content.style.paddingTop = `${this.headerHeight + 20}px`;
          }
        }
      }
    }
  }
}
</script>

<style>
.shop-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
}

/* 헤더 고정 스타일 - 유지 */
:deep(.nebula-header-wrapper) {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1100;
  background-color: #fff;
}

.shop-content {
  min-height: calc(100vh - 60px - 100px);
  /* paddingTop은 JavaScript에서 동적으로 설정됨 */
  margin-left: 250px;
  width: calc(100% - 250px);
  max-width: 1700px;
  box-sizing: border-box;
  transition: padding-top 0.3s ease; /* 부드러운 패딩 변경을 위한 트랜지션 추가 */
}

/* 고정된 사이드바 스타일 */
.fixed-left-sidebar {
  position: fixed;
  left: 0;
  /* top 속성은 JavaScript에서 동적으로 설정됨 */
  /* height 속성은 JavaScript에서 동적으로 설정됨 */
  width: 250px;
  z-index: 1000;
  overflow: visible;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  transition: top 0.3s ease; /* 부드러운 위치 변경을 위한 트랜지션 추가 */
}
.fixed-right-sidebar {
  position: fixed;
  right: 0.3%;
  top: 58%;
  transform: translateY(-50%);
  width: 80px; /* 메뉴용 넓이 */
  z-index: 1000;
  background-color: white;
  border-radius: 8px 0 0 8px;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
}

/* TOP 버튼 */
.top-button {
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #333;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  font-weight: bold;
}

@media (min-width: 769px) {
  .shop-content {
    min-height: calc(100vh - 60px - 100px);
    padding-top: 180px;
    margin-left: 250px; /* 좌측 사이드바 너비만큼 여백 추가 */
    width: calc(100% - 250px); /* 좌측 사이드바 너비를 제외한 너비 */
    max-width: 1700px; /* 최대 너비 제한 (선택 사항) */
    box-sizing: border-box;
  }
}

@media (max-width: 768px) {
  .shop-content {
    margin-left: 0;
    width: 100%;
    max-width: none;
  }
}
</style>